import AiAssistIcon from 'components/icons/aiAssist.svg?url';
import HomeIcon from 'components/icons/pages/home.svg?url';
import AccountsIcon from 'components/icons/metrics/accounts.svg?url';
import BookmarkIcon from 'components/icons/bookmark.svg?url';
import CarrierAppetiteIcon from 'components/icons/pages/carrier-appetite.svg?url';
import CodeIcon from 'components/icons/code.svg?url';
import ProducersIcon from 'components/icons/metrics/producers.svg?url';
import AccountExecutivesIcon from 'components/icons/metrics/accountExecutives.svg?url';
import ProductsIcon from 'components/icons/metrics/products.svg?url';
import MarketsIcon from 'components/icons/metrics/carriers.svg?url';
import ReportsIcon from 'components/icons/pages/report-studio.svg?url';
import AccountManagersIcon from 'components/icons/metrics/managers.svg?url';
import IndustriesIcon from 'components/icons/metrics/industries.svg?url';
import ProspectsIcon from 'components/icons/prospect.svg?url';
import GrowthIcon from 'components/icons/pages/growth.svg?url';
import RetentionIcon from 'components/icons/pages/retention.svg?url';
import RenewalsIcon from 'components/icons/renewals.svg?url';
import OverviewIcon from 'components/icons/overview.svg?url';
import O360ScoreIcon from 'components/icons/pages/o360.svg?url';
import DocumentsIcon from 'components/icons/files/document.svg?url';
import KPIIcon from 'components/icons/pages/kpi.svg?url';
import LossRunsIcon from 'components/icons/pages/loss-runs.svg?url';
import OpportunitiesIcon from 'components/icons/pages/opportunities.svg?url';
import InsightsIcon from 'components/icons/pages/insights.svg?url';
import AccountSettingsIcon from 'components/icons/accountSettings.svg?url';
import FavoriteIcon from 'components/icons/topbar/favorites.svg?url';
import FavoriteFilledIcon from 'components/icons/topbar/favoritesFilled.svg?url';
import FiltersIcon from 'components/icons/filters.svg?url';
import FiltersFilledIcon from 'components/icons/filters-filled.svg?url';
import CopyIcon from 'components/icons/topbar/copy.svg?url';
import CopyFilledIcon from 'components/icons/topbar/copyFilled.svg?url';
import SettingsIcon from 'components/icons/settings.svg?url';
import SwitchIcon from 'components/icons/topbar/switch.svg?url';
import LogOutIcon from 'components/icons/topbar/logout.svg?url';
import StorybookIcon from 'components/icons/storybook.svg?url';
import MonolineRatios from 'components/icons/monoline.svg?url';
import ActivitiesIcon from 'components/icons/activities.svg?url';
import WhatsNewIcon from 'components/icons/news.svg?url';

import {IconKey} from './types';

export const iconUrlMap = {
  [IconKey.AI]: AiAssistIcon,
  [IconKey.Opportunities]: OpportunitiesIcon,
  [IconKey.AccountExecutives]: AccountExecutivesIcon,
  [IconKey.AccountSettings]: AccountSettingsIcon,
  [IconKey.Home]: HomeIcon,
  [IconKey.Favorite]: FavoriteIcon,
  [IconKey.FavoriteFilled]: FavoriteFilledIcon,
  [IconKey.Filters]: FiltersIcon,
  [IconKey.FiltersFilled]: FiltersFilledIcon,
  [IconKey.Code]: CodeIcon,
  [IconKey.Copy]: CopyIcon,
  [IconKey.CopyFilled]: CopyFilledIcon,
  [IconKey.Accounts]: AccountsIcon,
  [IconKey.Activities]: ActivitiesIcon,
  [IconKey.Bookmark]: BookmarkIcon,
  [IconKey.CarrierAppetite]: CarrierAppetiteIcon,
  [IconKey.Producers]: ProducersIcon,
  [IconKey.Products]: ProductsIcon,
  [IconKey.Markets]: MarketsIcon,
  [IconKey.Reports]: ReportsIcon,
  [IconKey.AccountManagers]: AccountManagersIcon,
  [IconKey.Industries]: IndustriesIcon,
  [IconKey.Insights]: InsightsIcon,
  [IconKey.Prospects]: ProspectsIcon,
  [IconKey.Growth]: GrowthIcon,
  [IconKey.Retention]: RetentionIcon,
  [IconKey.Renewals]: RenewalsIcon,
  [IconKey.Overview]: OverviewIcon,
  [IconKey.O360Score]: O360ScoreIcon,
  [IconKey.Documents]: DocumentsIcon,
  [IconKey.KPI]: KPIIcon,
  [IconKey.LossRuns]: LossRunsIcon,
  [IconKey.Settings]: SettingsIcon,
  [IconKey.Switch]: SwitchIcon,
  [IconKey.Storybook]: StorybookIcon,
  [IconKey.LogOut]: LogOutIcon,
  [IconKey.MonolineRatios]: MonolineRatios,
  [IconKey.RetailClients]: AccountsIcon,
  [IconKey.WhatsNew]: WhatsNewIcon,
} satisfies Record<IconKey, string>;
